//This hook is used to manage automatic logout for a worker user. 
// It checks the worker's token expiration and logs them out if the token is expired or about to expire.


import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logoutWorker, resetWorkerUser } from '../features/workerAuth/workerAuthSlice';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const useWorkerAutoLogout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const logoutTimer = useRef(null);
  const [timeRemainingMinutes, setTimeRemainingMinutes] = useState(null);

  const workerUser = useSelector((state) => state.workerAuth.workerUser);

  useEffect(() => {
    if (workerUser && workerUser.webToken) {
     

      const decodedToken = jwtDecode(workerUser.webToken);
      const currentTime = Date.now();
      const tokenExpirationTime = decodedToken.exp * 1000; // Convert to milliseconds
      const timeRemaining = tokenExpirationTime - currentTime;

      if (timeRemaining > 0) {
        const timeInMinutes = Math.floor(timeRemaining / 60000); // Convert to minutes
        setTimeRemainingMinutes(timeInMinutes);

        logoutTimer.current = setTimeout(() => {
          handleLogout();
          toast.info("You've been logged out for security.");
        }, timeRemaining);
      } else {
        handleLogout(); // Logout immediately if token is already expired
      }
    }

    return () => {
      if (logoutTimer.current) {
        clearTimeout(logoutTimer.current);
      }
    };
  }, [workerUser]);

  const handleLogout = () => {
    if (logoutTimer.current) {
      clearTimeout(logoutTimer.current);
    }
    dispatch(logoutWorker());
    dispatch(resetWorkerUser());
    navigate('/workerLogin');
  };

  return { handleLogout, timeRemainingMinutes };
};

export default useWorkerAutoLogout;